import React, { FC } from 'react'
import { ContactFormValuesEnum } from '../types/contactFormValuesEnum'
import { Field } from 'react-final-form'
import { SelectOption } from '../../../types/fields/fieldsModel'
import { prospectTypeEnum } from '../../../enums/prospectTypeEnum'
import { useIntl } from 'react-intl'
import SelectField from '../../../components/fields/SelectField'

const ProspectTypeField: FC = () => {
	const intl = useIntl()

	const PROSPECT_TYPES: SelectOption[] = [{
		label: intl.formatMessage({
			id: 'creationContact.prospectType.contact',
			defaultMessage: 'Particulier',
			description: 'Prospect Type Contact label'
		}),
		value: prospectTypeEnum.CONTACT
	}, {
		label: intl.formatMessage({
			id: 'creationContact.prospectType.account',
			defaultMessage: 'Professionnel',
			description: 'Prospect Type Account label'
		}),
		value: prospectTypeEnum.ACCOUNT
	}]

	return (
		<Field
			name={ContactFormValuesEnum.PROSPECT_TYPE}
			component={SelectField}
			label="creationContact.contactForm.prospectType"
			options={PROSPECT_TYPES}
		/>
	)
}
export default ProspectTypeField